module.exports = __webpack_public_path__ + "static/media/OS.35a1bca9.jpg";